import styled from '@emotion/styled/macro';

import { FormSubmitButton } from '../../../../../styledComponents/UI/FormSubmitButton/FormSubmitButton';

export const StyledFormSubmitButton = styled(FormSubmitButton)`
  margin: 1rem 0 0;
`;
